import React from 'react';

class ChangeClassDetails extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      theClass:'',
      Teacher:'',
      TeacherPin:'',
      TeacherEmail:'',
      Assistant:'',
      AssistantPin:'',
      AssistantEmail:'',
      WhatsappNo:'',
      part2:false,
      data:[],
      showNxt:false,
    }
  }


  componentDidMount(){
    fetch('https://schoolportal.appsdesign.co.za/get_class/' + localStorage.getItem('schoolToken'))
    .then((response) => response.json())
    .then((responseJson) => {
  console.log(responseJson[0])
      this.setState({
        data: responseJson,

  }, function(){

      });
console.log(this.state.data)
    })
    .catch((error) =>{
      console.error(error);
    });

    }



    deleteClass = (val) =>{
      fetch('https://schoolportal.appsdesign.co.za/delete_class/' + val)
      .then(() => {
      alert('class data has been deleted')
      })
      .catch((error) =>{
        console.error(error);
      });

      }




  changetheClass = (event) =>{this.setState({theClass:event.target.value})}

  changeWhatsApp = (event) =>{this.setState({WhatsappNo:event.target.value})}

  changeTeacher = (event) =>{this.setState({Teacher:event.target.value})}

  changeTeacherPin = (event) =>{this.setState({TeacherPin:event.target.value})}

  changeTeacherEmail = (event) =>{this.setState({TeacherEmail:event.target.value})}

  changeAssistant = (event) =>{this.setState({Assistant:event.target.value})}

  changeAssistantPin = (event) =>{this.setState({AssistantPin:event.target.value})}

  changeAssistantEmail = (event) =>{this.setState({AssistantEmail:event.target.value})}


changeToPart2 = () =>{

  this.setState({
    part2:true,
    showNxt:true

  });

this.state.data.map(val =>{

if (val.assClass === this.state.theClass){

  this.setState({
    theClass:val.assClass,
    Teacher:val.teacher,
    TeacherPin:val.teacherPin,
    TeacherEmail:val.teacherEmail,
    Assistant:val.assistant,
    AssistantPin:val.assistantPin,
    AssistantEmail:val.assistantEmail,
    WhatsappNo:val.whatsappNum,
  });

}
return false;
})
}



updateClass = () =>{

  if(this.state.theClass === ''){

    alert('please add a class');
  }

else if(this.state.Teacher === ''){

    alert(`please add a Teacher`);
  }






              else{

                       fetch('https://schoolportal.appsdesign.co.za/update_class', {
                           method: 'post',
                           headers: {'Content-Type' : 'application/json'},
                           body: JSON.stringify({
                        classSchool:localStorage.getItem('schoolToken'),
                        assClass: this.state.theClass,
                        wapp:this.state.WhatsappNo,
                        teacher: this.state.Teacher,
                        teacherPin: this.state.TeacherPin,
                        teacherEmail: this.state.TeacherEmail,
                        assistant: this.state.Assistant,
                        assistantPin: this.state.AssistantPin,
                        assistantEmail: this.state.AssistantEmail,
                      })
                       })
                       .then(response => response)
                       .then(res =>{

                        this.setState({
                          theClass:'',
                          Teacher:'',
                          TeacherPin:'',
                          TeacherEmail:'',
                          Assistant:'',
                          AssistantPin:'',
                          AssistantEmail:'',
                          WhatsappNo:'',
                          part2:false,
                          data:[],
                          showNxt:false,
                        }, function() {alert(`${res}`)})



                       })

                }
              }


changeCancel = () =>{
this.setState({part2:false});
}


render(){

  const schoolclasses = this.state.data.map((schoolclass, i) => {

  return(

    <option key={i} value={schoolclass.assClass}>{schoolclass.assClass}</option>
  )


  });


  let theVclass;

  if(this.state.part2 && this.state.showNxt){

    theVclass = this.state.data.map( (theclass,i) => {
  console.log(theclass);
    if (theclass.assClass === this.state.theClass){




    return (

  <div key={i} className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,backgroundColor:'white'}}>
        <h1>Enter Class Details</h1>

<div>
        <label htmlFor="class" style={{marginRight:45}}>
        Class</label>
        <input
        type="text"
        placeholder="Class"
        defaultValue={theclass.assClass}
        id="class"
        className="pa2 ma2"
        onKeyUp={this.changetheClass}
        />
        <br/>

        <label htmlFor="whatsapp" style={{marginRight:40}}>
        WhatsApp</label>
        <input
        type="text"
        placeholder="WhatsApp Group Number"
        id="whatsapp"
        className="pa2 ma2"
        onKeyUp={this.changeWhatsApp}
        />
        <br/>

        <label htmlFor="teacher" style={{marginRight:25}}>
        Teacher</label>
        <input
        type="text"
        placeholder="Teacher"
        defaultValue={theclass.teacher}
        id="teacher"
        className="pa2 ma2"
        onKeyUp={this.changeTeacher}
        />
        <br/>

        <label htmlFor="teacherno">
        Teacher Pin</label>
        <input
        type="text"
        placeholder="Teacher Pin"
        defaultValue={theclass.teacherPin}
        id="teacherno"
        className="pa2 ma2"
        onKeyUp={this.changeTeacherPin}
        />
        <br/>


        <label htmlFor="teacheremail">
        Teacher Email</label>
        <input
        type="text"
        placeholder="Teacher Email"
        defaultValue={theclass.teacherEmail}
        id="teacheremail"
        className="pa2 ma2"
        onKeyUp={this.changeTeacherEmail}
        />
        <br/>

        <label htmlFor="assistant" style={{marginRight:25}}>
        Assistant</label>
        <input
        type="text"
        placeholder="Assistant"
        defaultValue={theclass.assistant}
        id="assistant"
        className="pa2 ma2"
        onKeyUp={this.changeAssistant}
        />
      <br/>

        <label htmlFor="assistantpin" style={{marginRight:0}}>
        Assistant Pin</label>
        <input
        type="text"
        placeholder="Assistant Pin"
        defaultValue={theclass.assistantPin}
        id="assistantpin"
        className="pa2 ma2"
        onKeyUp={this.changeAssistantPin}
        />
        <br/>

        <label htmlFor="assistantemail" style={{marginRight:0}}>
        Assistant Email</label>
        <input
        type="text"
        placeholder="Assistant Email"
        defaultValue={theclass.assistantEmail}
        id="assistantemail"
        className="pa2 ma2"
        onKeyUp={this.changeAssistantEmail}
        />
        <br/>





          <button className="br3 pa3 bg-orange br-orange" onClick={this.changeCancel}>Cancel</button> &nbsp;
          <button className="br3 pa3 bg-red br-red" onClick={() => this.deleteClass(theclass._id)}>Delete</button> &nbsp;
          <button className="br3 pa3 bg-blue br-blue" onClick={this.updateClass}>Save</button>
</div>
        </div>
    );


    }


//this.setState({showNxt:false});
return false;
    })



  }



return(



!this.props.isAuthed ? <h1> your out, sorry not authenticated </h1>


:(
  !this.state.part2 ?
  <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,backgroundColor:'white'}}>

  <h1> Change Class Details </h1>


  <label htmlFor="class">
  Child Class
  <select
  id="class"

  className="pa2 ma2"
  onChange={this.changetheClass}
  >
<option value="">--please select--</option>
  {schoolclasses}
        </select>

  </label><br/>


  <button className="br3 pa3 bg-blue br-blue"  style={{width:200, alignSelf:'center'}} onClick={this.changeToPart2}>Continue</button>



  </div> :
  <div>
{theVclass}
  </div>
)







)

}

}

export default ChangeClassDetails;



// WEBPACK FOOTER //
// ./src/components/ChangeClassDetails/ChangeClassDetails.js